import { post, get, put, del } from "../api.helper/root";

const rootUri = process.env.VUE_APP_ROOT_BASE_URL;

const registerUri = rootUri + "/onboarduser";
const resendCodeUri = rootUri + "/resendcode";
const confirmUserUri = rootUri + "/confirmuser";
const changePasswordUri = rootUri + "/settings/changepassword";
const setAdminUri = rootUri + "/settings/updateprofile";
const companyInfoUri = rootUri + "/get-company-info";
const getAdminUri = rootUri + "/settings/getprofile";
const addMcBasicDetailsUri = rootUri + "/account-setup/add-mc-basic-details";
const getAccountStatusUri =
  rootUri + "/account-setup/get-mc-setup-status?mcAdminCognitoID=";
const verifyMfaTokenUri = `${rootUri}/settings/enablemfa`;
const toggleMfaMfaUri = `${rootUri}/settings/togglemfa`;
const getMfaStatusUri = `${rootUri}/settings/mfastatus`;
const removeLogoUri = rootUri + "/profile/logo";
const getActiveSubscriptionUri = rootUri + "/dashboard/active-subscription";
const getStaffSummaryUri = rootUri + "/dashboard/staff-summary";
const getStaffChartAnalysisUri = rootUri + "/dashboard/staff-analysis";
const getStaffVerificationSummaryUri =
  rootUri + "/dashboard/staff-verification-summary";
const getUserAgreementPDFContentUri = rootUri + "/user-agreement";
const frontdeskFeesUri = rootUri + "/settings/frontdesk-fees";

const config = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

export const register = userData => post(registerUri, userData);

export const resendCode = userEmail => post(resendCodeUri, userEmail);

export const confirmUser = userData => post(confirmUserUri, userData);

export const changePassword = userData => post(changePasswordUri, userData);

export const verifyMfaToken = userData => post(verifyMfaTokenUri, userData);

export const setAdmin = userData => post(setAdminUri, userData);

export const getCompanyInfo = userData => post(companyInfoUri, userData);

export const toggleMfa = userData => post(toggleMfaMfaUri, userData);

export const getMfaStatus = () => get(getMfaStatusUri);

export const getAdmin = tenantId =>
  get(getAdminUri, {
    headers: {
      tenantId
    }
  });

export const getAccountStatus = params =>
  get(`${getAccountStatusUri}${params}`);

export const addMcBasicDetails = userData =>
  put(addMcBasicDetailsUri, userData, config);

export const removeLogo = (profileTypeNumber, fileName, tenantId) =>
  del(
    `${removeLogoUri}?ProfileType=${profileTypeNumber}&FileName=${fileName}`,
    {},
    {
      headers: {
        tenantId
      }
    }
  );

export const getActiveSubscription = tenantId =>
  get(getActiveSubscriptionUri, {
    headers: {
      tenantId
    }
  });

export const getStaffSummary = (timeLine, tenantId) =>
  get(`${getStaffSummaryUri}?Timeline=${timeLine}`, {
    headers: {
      tenantId
    }
  });

export const getStaffChartAnalysis = (targetYear, timeLine, tenantId) =>
  get(
    `${getStaffChartAnalysisUri}?TargetYear=${targetYear}&Timeline=${timeLine}`,
    {
      headers: {
        tenantId
      }
    }
  );

export const getStaffVerificationSummary = tenantId =>
  get(getStaffVerificationSummaryUri, {
    headers: {
      tenantId
    }
  });

export const getUserAgreementPDFUrlOrHtmlString = format =>
  get(`${getUserAgreementPDFContentUri}?Format=${format}`);

export const getFrontdeskFees = tenantId =>
  get(frontdeskFeesUri, {
    headers: {
      tenantId
    }
  });

export const updateFrontdeskFees = (tenantId, userData) =>
  put(frontdeskFeesUri, userData, {
    headers: {
      tenantId
    }
  });
